import { bsc, bscTestnet } from "wagmi/chains";


export const contract = {
  97: {
    STAKE_ADDRESS: "0xd65983ab9e87258f6ad6c0b772d0ee0c870933ce",
    MULTICALL_ADDRESS: "0xa54fE4a3DbD1Eb21524Cd73754666b7E13b4cB18",
    TOKEN_ADDRESS: "0x83d69974440c68427bf90659b999f8a384e96a20",
    USDT_ADDRESS : "0xc7b6278c411564729c02548a5742e6d5788bac33"
  },
  56: {
    STAKE_ADDRESS: "0x381e58e3edadc94a28593ec5d4fb821bfd5ae239",
    MULTICALL_ADDRESS: "0x2cc8fe3e04d7b1edaeb42e2e73f78c4cac074116",
    TOKEN_ADDRESS: "0xFf1224DA66831e1ED1d88E6dD95CA875EA13AfbF",
    USDT_ADDRESS : "0x55d398326f99059fF775485246999027B3197955"
  }
}

export const DEFAULT_CHAIN = 56;
export const DEFAULT_RPC = "https://bsc-dataseed1.binance.org/"
// export const DEFAULT_RPC = "https://data-seed-prebsc-2-s1.binance.org:8545/"
export const PROJECT_ID = "27b9720018bf7f8740936e6a6eb28604";
export const DECIMALS = 18;
export const SYMBOL = 'EAT';
export const EXPLOER = 'https://bscscan.com/';
export const chains = [bsc]






